import React from 'react';

import * as amplitude from '@amplitude/analytics-browser';
import { App } from 'App';
import 'i18n';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from 'report-web-vitals';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { initAuthInterceptor } from 'shared/interceptors/auth-interceptor';
import { initGuestSmartAssistantInterceptor } from 'shared/interceptors/guest-smart-assistant-interceptor';
import { initThrottleInterceptor } from 'shared/interceptors/throttle-interceptor';
import { Navigator } from 'shared/utils/navigation';

const isGuestPage = [ROUTE_LINKS.guestSmartAssistant.slice(1), ROUTE_LINKS.legacyGuestSmartAssistant.slice(1)].includes(
  window.location.pathname.split('/')[1]
);

// Initialize Google Analytics
ReactGA.initialize('G-3MVT0NB1KC');

// Initialize LogRocket for session replays and Amplitude for products analytics
if (
  window.location.hostname !== 'localhost' &&
  // Do not initialize LogRocket and Amplitude for Guest Smart Assistant
  !isGuestPage
) {
  amplitude.init('2305621c24021830b1e7dc84d506f513');
}

initAuthInterceptor();
initGuestSmartAssistantInterceptor();
initThrottleInterceptor();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
document.title = isGuestPage ? '' : 'Droxy';

root.render(
  <Router>
    <Navigator />
    <App />
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
